import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import AppLandingPage from "../../All_Projects_Landing_Pages/AppLandingPage";
import Report from "../../common/Report";
import { FieldsProvider } from "../../../context/FieldsContext";
import AICVDPdfDetails from "../../../components/pdfReports/AICVDPdfReport";
import {
  getImagesFromDB,
  fetchAndStoreImages,
} from "../../../utils/imageUtils";
import AICVDDetailsPage from "../../All_Project_Components/AicvdComponent";

const AICVDRoutes = (props) => {
  const AICVD_LANDING_URL =
    "https://clinical-server-apis.azurewebsites.net/fields/aicvd";
  const AICVD_REPORT_URL =
    "https://clinical-server-apis.azurewebsites.net/aicvd";

  const [formDetails, setFormDetails] = useState({});
  const [PdfInfo, setPDFDetails] = useState({});
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState([]);
  const [units, setUnits] = useState({});

  const app = "aicvd";

  const color = "rgba(255, 0, 0, 0.719)";
  const secondaryColor = "rgba(243, 25, 25, 0.72)";
  const button_hover_color = "#ff9999";
  const surface_color = "#f2ecee";
  const surface_hover_color = "#e8e0e8";
  const surface_highlight_color = "#dcdaf5";
  const gender_highlight_color = "#675496";
  const button_color = "rgb(123, 104, 171)";
  const surface_highlight_dark_color = "rgb(103, 84, 150)";

  const form_details = (props) => {
    const details = {
      patient_id: props.patient_id,
      name: props.name,
      age: props.age,
      gender: props.gender,
      location: props.location,
      email: props.email,
      phone: props.phone,
      height: props.height,
      weight: props.weight,
      bmi: props.BMI,
      heart_rate: props.heart_rate,
      systolic_bp: props.systolic_bp,
      diastolic_bp: props.diastolic_bp,
      respiration_rate: props.respiration_rate,
      pulse_rhythm: props.pulse_rhythm,
      heart_symptoms: props.heart_symptoms,
      pyschological_stress: props.pyschological_stress,
      diet: props.diet,
      smoking: props.smoking,
      tobacco: props.tobacco,
      alcohol: props.alcohol,
      physical_activity: props.physical_activity,
      hypertension: props.hypertension,
      dyslipidaemia: props.dyslipidaemia,
      heart_disease: props.heart_disease,
      family_heart_disease: props.family_heart_disease,
      diabetes: props.diabetes,
    };

    const pdf_details = {
      basic_info: {
        UHID: props.patient_id,
        Name: props.name,
        Age: props.age,
        Gender: props.gender,
        Location: props.location,
        Mobile: props.phone,
      },
      "Vital Signs": {
        Height: props.height,
        Weight: props.weight,
        BMI: props.BMI,
      },
      "Heart Health": {
        "Chest Pain / Shortness of Breath/ Other Symptoms":
          props.heart_symptoms,
        "Psychological Stress": props.pyschological_stress,
        "Pulse Rhythm": props.pulse_rhythm,
        "Heart Rate": props.heart_rate,
        "Systolic BP": props.systolic_bp,
        "Diastolic BP": props.diastolic_bp,
        "Respiration Rate": props.respiration_rate,
      },

      "Life Style": {
        Diet: props.diet,
        Alcohol: props.alcohol,
        Smoking: props.smoking,
        Tobacco: props.tobacco,
        "Physical Activity": props.physical_activity,
      },

      "Medical History": {
        "Diabetes Mellitus": props.diabetes,
        Hypertension: props.hypertension,
        Dyslipidaemia: props.dyslipidaemia,
        "History of Heart Disease": props.heart_disease,
        "Family History of Heart Disease": props.family_heart_disease,
      },
    };

    const units = {
      Height: "cm",
      Weight: "kg",
      BMI: "kg/m2",
      "Heart Rate": "/min",
      "Systolic BP": "/mm of Hg",
      "Diastolic BP": "/mm of Hg",
      "Respiration Rate": "/min",
    };
    setUnits(units);
    setFormDetails(details);
    setPDFDetails(pdf_details);
  };

  useEffect(() => {
    const loadImages = async () => {
      try {
        const storedImages = await getImagesFromDB(app);
        if (storedImages.length > 0) {
          setImages(storedImages);
        } else {
          const urls = [
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo-logo.png",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/iStock-644984072_vhiiap_c_scale%252Cw_1400.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicvd-app-page-1.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/aicvd-app-page-2.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/intepretation-img-1.jpg",
            "https://clinicalpubres.blob.core.windows.net/pubres/clinical-img/apollo_certificate_MD%20763515.png",
          ];
          await fetchAndStoreImages(app, urls, setImages);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        setLoading(false);
      }
    };
    loadImages();
  }, []);

  return (
    <FieldsProvider>
      <Routes>
        <Route
          path="/"
          element={
            <AppLandingPage
              LANDING_URL={AICVD_LANDING_URL}
              app={app}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
              images={images}
              loading={loading}
            />
          }
        />
        <Route
          path="patient-details"
          element={
            <AICVDDetailsPage
              app={app}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
              gender_highlight_color={gender_highlight_color}
              surface_highlight_dark_color={surface_highlight_dark_color}
              button_color={button_color}
              form_details={form_details}
            />
          }
        />
        <Route
          path="report"
          element={
            <Report
              app={app}
              formDetails={formDetails}
              REPORT_URL={AICVD_REPORT_URL}
              surface_color={surface_color}
              surface_highlight_color={surface_highlight_color}
              surface_hover_color={surface_hover_color}
              color={color}
              button_hover_color={button_hover_color}
              secondaryColor={secondaryColor}
            />
          }
        />
        <Route
          app={app}
          path="pdfreport"
          element={
            <AICVDPdfDetails
              formDetails={formDetails}
              PdfInfo={PdfInfo}
              color={color}
              units={units}
            />
          }
        />
      </Routes>
    </FieldsProvider>
  );
};

export default AICVDRoutes;
